import * as React from "react";
import type { SVGProps } from "react";
const SvgGetMore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={66}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#D3ECF8"
      d="M1.314 41.246h62.86S56.792 25.72 50.432 27.247c-6.361 1.528-8.655 5.09-15.777 1.017-7.127-4.072-10.433-9.16-16.798-5.088-6.36 4.071-12.662 16.287-16.415 16.287 0 0-.128 1.91-.128 1.783ZM64.307 10.778H1.456v7.309h62.851v-7.31Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M2.456 11.609V62h61.088V11.609H2.456Zm-2-.53c0-.812.658-1.47 1.47-1.47h62.148c.812 0 1.47.658 1.47 1.47V62.53a1.47 1.47 0 0 1-1.47 1.47H1.926a1.47 1.47 0 0 1-1.47-1.47V11.08Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M64.913 19.092H1.456v-2h63.457v2Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M47.888 48.883a1.655 1.655 0 1 0 0-3.31 1.655 1.655 0 0 0 0 3.31ZM52.565 48.883a1.655 1.655 0 1 0 0-3.31 1.655 1.655 0 0 0 0 3.31ZM57.24 48.883a1.655 1.655 0 1 0 0-3.31 1.655 1.655 0 0 0 0 3.31Z"
    />
    <path
      fill="#26A3DD"
      d="M47.888 53.525a1.655 1.655 0 1 0 0-3.31 1.655 1.655 0 0 0 0 3.31Z"
    />
    <path
      fill="#D3ECF8"
      d="M52.565 53.525a1.655 1.655 0 1 0 0-3.31 1.655 1.655 0 0 0 0 3.31ZM57.24 53.525a1.655 1.655 0 1 0 0-3.31 1.655 1.655 0 0 0 0 3.31ZM47.888 58.171a1.655 1.655 0 1 0 0-3.31 1.655 1.655 0 0 0 0 3.31ZM43.118 48.883a1.655 1.655 0 1 0 0-3.31 1.655 1.655 0 0 0 0 3.31ZM43.118 53.525a1.655 1.655 0 1 0 0-3.31 1.655 1.655 0 0 0 0 3.31ZM43.118 58.171a1.655 1.655 0 1 0 0-3.31 1.655 1.655 0 0 0 0 3.31ZM38.344 48.883a1.655 1.655 0 1 0 0-3.31 1.655 1.655 0 0 0 0 3.31Z"
    />
    <path
      fill="#26A3DD"
      d="M38.344 53.525a1.655 1.655 0 1 0 0-3.31 1.655 1.655 0 0 0 0 3.31Z"
    />
    <path
      fill="#D3ECF8"
      d="M38.344 58.171a1.655 1.655 0 1 0 0-3.31 1.655 1.655 0 0 0 0 3.31ZM33.447 48.883a1.655 1.655 0 1 0 0-3.31 1.655 1.655 0 0 0 0 3.31ZM33.447 53.525a1.655 1.655 0 1 0 0-3.31 1.655 1.655 0 0 0 0 3.31ZM33.447 58.171a1.655 1.655 0 1 0 0-3.31 1.655 1.655 0 0 0 0 3.31ZM52.565 58.171a1.655 1.655 0 1 0 0-3.31 1.655 1.655 0 0 0 0 3.31Z"
    />
    <path
      fill="#26A3DD"
      d="M57.24 58.171a1.655 1.655 0 1 0 0-3.31 1.655 1.655 0 0 0 0 3.31Z"
    />
    <path
      fill="#D3ECF8"
      d="M16.394 58.677a6.68 6.68 0 1 0 0-13.36 6.68 6.68 0 0 0 0 13.36Z"
    />
    <path
      fill="#26A3DD"
      d="M23.073 51.998a6.68 6.68 0 0 0-6.68-6.68v6.68h6.68Z"
    />
  </svg>
);
export default SvgGetMore;
